import { Trans } from '@lingui/macro';
import { Button } from '@mantine/core';

import {
  ETripSeatchItemAvailable,
  TTripSeatchItem,
} from '../../pages/search/types';
import { TrainRouteInfo } from '../train-route-info/train-route-info';
import { UiCard } from '../ui/ui-card/ui-card';

export const SearchRouteCardData = ({
  trip,
  onBookTiket,
}: {
  trip: TTripSeatchItem;
  onBookTiket: (params: { tripid: string }) => void;
}) => {
  const handleBookTicket = () => {
    onBookTiket({ tripid: String(trip.id) });
  };
  return (
    <UiCard>
      <TrainRouteInfo trip={trip} />
      <Button
        mt="md"
        size="lg"
        fullWidth
        onClick={handleBookTicket}
        disabled={trip.available === ETripSeatchItemAvailable.noEmptySeats}
      >
        {trip.available === ETripSeatchItemAvailable.noEmptySeats ? (
          <Trans>Нет свободных мест</Trans>
        ) : (
          <Trans>Приобрести билеты</Trans>
        )}
      </Button>
    </UiCard>
  );
};
